/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Form, Input, Button, Select, InputNumber } from "antd";
import { updateChallengeEntry, getChallengeEntry } from "../../features/challenge/challengeSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message as msg } from "antd";
import { useParams } from "react-router-dom";

const { Option } = Select;

const ViewChallengeEntries = () => {
  const { id } = useParams();
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, updating, message, isUpdateSuccess, challengeEntry } = useSelector(
    (state) => state.challenge
  );
  const [form] = Form.useForm();

  const onFinish = (values) => {
    const data = { ...values };
    data.status = parseInt(values.status);
    dispatch(updateChallengeEntry({ id, data }));
  };

  useEffect(() => {
    loadChallengeEntry();
  }, []);

  useEffect(() => {
    if (challengeEntry) {
      form.setFieldsValue({
        player_name: challengeEntry?.user?.first_name + " " + challengeEntry?.user?.last_name,
        club_name: challengeEntry?.club_name,
        social_media_url: challengeEntry?.social_media_url,
        points: challengeEntry?.points,
        status: challengeEntry?.status?.toString(),
      });
    }
  }, [challengeEntry]);

  useEffect(() => {
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }

    if (isUpdateSuccess) {
      messageApi.open({
        type: "success",
        content: "Video submission is updated successfully",
      });
      navigate("/admin/hole-out-video-submissions");
    }
  }, [isError, message, isUpdateSuccess, messageApi, navigate]);

  const loadChallengeEntry = () => {
    dispatch(getChallengeEntry(id));
  };

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Video Submission</h3>
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item
          label="Player Name"
          name="player_name"
          rules={[{ required: true, message: "Please input the player name!" }]}
        >
          <Input disabled />
        </Form.Item>

        <Form.Item
          label="Club Name"
          name="club_name"
          rules={[{ required: true, message: "Please input the description!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Social Media URL"
          name="social_media_url"
          rules={[{ required: false, message: "Please input the social media url!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Points"
          name="points"
          rules={[{ required: true, message: "Please input the points!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select the status!" }]}
        >
          <Select>
            <Option value="1">Pending</Option>
            <Option value="2">Approved</Option>
            <Option value="3">Rejected</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={updating}>
            {updating ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ViewChallengeEntries;
